import React from 'react'
import { useState } from 'react';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import MyModal from '../../../../../../../../UI/modal/MyModal';
import { Tooltip } from '@mui/material';
import AgreeDeputyDirectorSupplyBillItemAllForm from './AgreeDeputyDirectorSupplyBillItemAllForm';

const AgreeDeputyDirectorSupplyAllButton = ({ supplyBillId, supplyBillItems }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        {/* <SupplyBillAgreeIco
            onClick={e => setOpen(true)}
            text={'Погодження зам директора постачання'}
            ico={<Diversity2Icon />}
            value={supplyBillItem.isAgreeDeputyDirectorSupply}
        /> */}
        <Tooltip
            title={'Погодження зам директора постачання'}
            onClick={e => setOpen(true)}
        >
            <Diversity2Icon />
        </Tooltip>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Погодження'}
            disableClickOutside={true}
            content={
                <AgreeDeputyDirectorSupplyBillItemAllForm
                    supplyBillId={supplyBillId}
                    supplyBillItems={supplyBillItems}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AgreeDeputyDirectorSupplyAllButton